import { PLANNER_URL } from '../common/environment';
import Service from './App';

export async function fetchFeatureFlags(): Promise<Map<string, boolean>> {
  const r = await Service.http!.get(`${PLANNER_URL}/v1/featureflags/`);
  return r.data;
}
